/**
 * Theme initialization - runs synchronously to prevent flash of wrong theme.
 * Must load in <head> before body renders.
 */

// Get saved theme or default to system preference
const savedTheme = localStorage.getItem("theme");
const systemPrefersDark = window.matchMedia(
  "(prefers-color-scheme: dark)",
).matches;
const initialTheme = savedTheme || (systemPrefersDark ? "dark" : "light");

// Apply theme
document.documentElement.dataset.theme = initialTheme;

// Toggle function
(window as unknown as { toggleTheme: () => void }).toggleTheme = function () {
  const currentTheme = document.documentElement.dataset.theme;
  const newTheme = currentTheme === "dark" ? "light" : "dark";
  document.documentElement.dataset.theme = newTheme;
  localStorage.setItem("theme", newTheme);
};

// Listen for system theme changes (only if user hasn't manually set preference)
window
  .matchMedia("(prefers-color-scheme: dark)")
  .addEventListener("change", (e) => {
    if (!localStorage.getItem("theme")) {
      document.documentElement.dataset.theme = e.matches ? "dark" : "light";
    }
  });

// Listen for theme toggle event
window.addEventListener(
  "ft-theme-toggle",
  (window as unknown as { toggleTheme: () => void }).toggleTheme,
);

// Delegate clicks on [data-action="theme"] buttons
document.addEventListener("click", (e) => {
  const target = (e.target as HTMLElement).closest('[data-action="theme"]');
  if (target) window.dispatchEvent(new Event("ft-theme-toggle"));
});
